document.addEventListener('click', function (e) {
  const notifyLabel = e.target.closest('label.notify-me');
  const notifyTrigger = e.target.closest('.quick-add__modal_notify');
  const stockIndicatorText = notifyLabel?.querySelector('.stock-indicator')?.textContent?.trim() || 'Join Waitlist';

  let stockIndicatorTextHeading = notifyLabel?.querySelector('.stock-indicator')?.textContent?.trim() || '';

  if (stockIndicatorText === 'Notify Me') {
    stockIndicatorTextHeading = 'Sold out Notify Me';
  } else if (stockIndicatorText === 'Join Waitlist') {
    stockIndicatorTextHeading = 'COMING SOON JOIN WAITLIST';
  } else {
    stockIndicatorTextHeading = stockIndicatorTextHeading || 'Coming Soon Join Waitlist';
  }  

  if (!notifyLabel && !notifyTrigger) return;

  const triggerEl = notifyLabel || notifyTrigger;
  const inputEl = notifyLabel?.querySelector('input[type="radio"]');

  const clickedVariantId = notifyLabel && inputEl
    ? (
        inputEl.dataset.variantId ||          // ✅ FIRST priority — works on PDP & PLP
        notifyLabel.dataset.variantId ||      // fallback on label attribute
        inputEl.value ||                      // PLP fallback: value = real variant ID
        null
      )
    : null;

  const clearNotifySelection = () => {
    if (inputEl) {
      inputEl.checked = false;
    }
  };

  const quickAddModal = document.querySelector('.quick-add-modal-desktop.open');
  if (quickAddModal) {
    quickAddModal.classList.remove('open');
  } 

  if (document.getElementById('notify-modal')) return;

  const parent = triggerEl.closest('.quick-add-component, .product-card, variant-picker');
  const variantOptions = parent?.dataset.variants
    ? JSON.parse(parent.dataset.variants)
    : [];
  console.log('variantOptions:', variantOptions);

  const outOfStockVariants = variantOptions.filter(v => v.available === false);
  const variantHTML = outOfStockVariants.map(v => `
    <button type="button" class="size-box" data-variant-id="${v.id}"><span>${v.size}</span><span class="ntm-placeholder">${stockIndicatorText}</span></button>
  `).join('');

  const modal = document.createElement('div');
  modal.id = 'notify-modal';
  modal.innerHTML = `
    <div class="notify-modal">
      <div class="notify-drawer__content drawer__content">
        <div class="notify-header">
           ${stockIndicatorTextHeading}
          <button class="notify-close" aria-label="Close">✕</button>
        </div>
        <div class="notify-body">
          <div class="notify-set1">
            ${outOfStockVariants.length > 1 ? `
            <div class="quick-title">
              <span>SIZE</span>
            </div>
            <div class="size-grid">${variantHTML}</div>
            <div class="notify-divider"></div>
          ` : ''}
            <div class="back-in-stock-form">
              <label for="notify_email">Enter your email address and we will notify you when the item becomes available.</label>
              <input type="email" id="notify_email" placeholder="Email*" required/>
              <div class="notify-checkbox">
                <input type="checkbox" id="customer_accepts_marketing" name="accepts_marketing" checked />
                <label for="customer_accepts_marketing">I agree to subscribe to the mailing list to be the first to know about new collections.</label>
              </div>
            </div>
            <div class="notify-divider"></div>
          </div>
          <div class="notify-form-message" style="display:none; margin-top: 1em;"></div>
            <div class="back-in-stock-form__submit">
              <button class="notify-submit button">SUBMIT</button>
            </div>
            <p class="notify-privacy">
              <small>By clicking “Submit” you agree to our 
              <a href="/pages/privacy-policy" target="_blank">privacy policy</a></small>
            </p>
                    
        </div>
      </div>
      <div class="custom-filter-drawer__overlay drawer__overlay"></div>
    </div>
  `;

  document.body.appendChild(modal);
  requestAnimationFrame(() => modal.classList.add('open'));

  //modal.querySelector('.notify-close').addEventListener('click', () => modal.remove());
  //modal.querySelectorAll('.notify-close, .custom-filter-drawer__overlay').forEach(el => {
  //  el.addEventListener('click', () => modal.remove());
  //});

  function clearVariantParamFromUrl() {
    const url = new URL(window.location.href);
    url.searchParams.delete('variant'); // remove ?variant=...
    // Preserve other params + hash if any
    window.history.replaceState({}, '', url.toString());
  }


  modal.querySelectorAll('.notify-close, .custom-filter-drawer__overlay').forEach(el => {
    el.addEventListener('click', () => {
      clearNotifySelection();
      clearVariantParamFromUrl();
      modal.remove();
    });
  }); 


  let selectedVariantId = null;

  // Priority 1: Use clicked variant ID if available
  if (clickedVariantId) {
    selectedVariantId = clickedVariantId;
  }
  // Priority 2: If no clicked variant and only one OOS variant, use that
  else if (outOfStockVariants.length === 1) {
    selectedVariantId = String(outOfStockVariants[0].id);
  }

  // Auto-preselect button if we have a selectedVariantId and size grid exists
  if (selectedVariantId && outOfStockVariants.length > 1) {
    let btnToSelect = modal.querySelector(`.size-box[data-variant-id="${selectedVariantId}"]`);

    if (!btnToSelect) {
      // Fallback: match by button text
      btnToSelect = Array.from(modal.querySelectorAll('.size-box')).find(button =>
        button.textContent.trim() === selectedVariantId
      );
    }

    if (btnToSelect) {
      // Remove 'selected' from all buttons first
      modal.querySelectorAll('.size-box.selected').forEach(btn => {
        btn.classList.remove('selected');
      });

      btnToSelect.classList.add('selected');
    }
  }


  modal.querySelectorAll('.size-box').forEach(button => {
    button.addEventListener('click', () => {
      modal.querySelectorAll('.size-box').forEach(b => b.classList.remove('selected'));
      button.classList.add('selected');
      selectedVariantId = button.dataset.variantId;
      console.log('variantID', selectedVariantId);
    });
  });

  /*if (clickedVariantId) {
    const btnToSelect = modal.querySelector(`.size-box[data-variant-id="${clickedVariantId}"]`);
    if (btnToSelect) {
      btnToSelect.classList.add('selected');
      selectedVariantId = clickedVariantId;
    }
  }*/

  modal.querySelector('.notify-submit').addEventListener('click', (e) => {
    e.preventDefault();

    const modal = e.target.closest('#notify-modal'); // 🔥 ENSURE modal is correctly referenced
    if (!modal) return;

    const email = modal.querySelector('#notify_email').value;
    const agreed = modal.querySelector('#customer_accepts_marketing').checked;

    const messageBox = modal.querySelector('.notify-form-message');
    const notifyPrivacy = modal.querySelector('.notify-privacy');
    messageBox.style.display = 'block';

    if (outOfStockVariants.length > 1 && !selectedVariantId) {
      messageBox.innerHTML = '<p class="error-message">Please select a size.</p>';
      return;
    }
    if (!email) {
      messageBox.innerHTML = '<p class="error-message">Please enter your email.</p>';
      return;
    }



    //const productId = {{ product.id | json }};
    const productId = parent?.dataset.productId;
    const productHandle = parent?.dataset.productHandle;


    const variantId = selectedVariantId;
    const selectedVariant = variantOptions.find(v => v.id == selectedVariantId);
    const selectedSKU = selectedVariant?.sku || '';
    const selectedPrice = selectedVariant?.price || '';
    const productData = document.querySelector('quick-add-component');      

    console.log('productId:', productId, 'variantId:', variantId, 'selectedVariant:', selectedVariant, 'selectedSKU:', selectedSKU, 'selectedPrice:', selectedPrice );

    const notificationCallback = function(data) {
      console.log("BIS response:", data); // For debugging
      if (!modal) return;
      if (data.status == 'OK') {
        console.log('Back in Stock notification succeeded:', data.message);

        if (notifyPrivacy) {
          notifyPrivacy.style.display = 'none';
        }

        const oldBtn = modal.querySelector('.notify-submit');
        if (oldBtn) {
          const closeBtn = oldBtn.cloneNode(true);
          closeBtn.textContent = "Close";
          oldBtn.replaceWith(closeBtn);

          closeBtn.addEventListener('click', () => {
            clearNotifySelection();
            clearVariantParamFromUrl();
            modal.remove();            
          });
        }

        const messageBox = modal.querySelector('.notify-form-message');

        if (messageBox) {
          messageBox.innerHTML = `<p class="success-message">You’re on the waitlist! We will notify you when the item becomes available.</p> <p>&nbsp;</p><div class="notify-divider"></div>`;
          messageBox.style.display = 'block';
        }

        // Optionally hide the form or size selection after success
        const notifySet1 = modal.querySelector('.notify-set1');
        if (notifySet1) notifySet1.style.display = 'none';

        const submitBtn = modal.querySelector('.notify-submit');
        if (submitBtn) submitBtn.style.display = 'none';


      } else if (data?.errors) {
        let msg = '';
        for (const k in data.errors) {
          msg += `${k}: ${data.errors[k].join(', ')}\n`;
        }
        alert(msg);
      } else {
        alert("Unexpected response from the server.");
        console.warn("Unexpected BIS response:", data);
      }
    };

    function waitForBIS(callback, timeout = 5000) {
      const interval = 100;
      let waited = 0;
      const check = setInterval(() => {
        if (typeof BIS !== 'undefined' && typeof BIS.create === 'function') {
          clearInterval(check);
          callback();
          console.log('✅ BIS is available');
        } else if ((waited += interval) >= timeout) {
          clearInterval(check);
          alert("Notification service unavailable. Please try again later.");
          console.warn("BIS SDK did not load in time.");
        }
      }, interval);
    }

    waitForBIS(() => {
      const acceptsMarketing = document.querySelector('#customer_accepts_marketing')?.checked || false;
      BIS.create(email, variantId, productId, {
        handle: productHandle,
        sku: selectedSKU,
        price: selectedPrice,
        accepts_marketing: acceptsMarketing
      }, function(err, result) {
        console.log("BIS callback triggered");
        if (err) {
          alert("There was an error submitting the notification.");
          console.error("BIS error:", err);
          return;
        }
        notificationCallback(result);
      });
      // Show confirmation immediately (optimistic UI)
      showConfirmationMessage();
      console.log("BIS payload:", {
        email, variantId, productId,
        handle: productHandle,
        sku: selectedSKU,
        price: selectedPrice,
        accepts_marketing: acceptsMarketing
      });
    });

    function showConfirmationMessage() {
      const notifySet1 = modal.querySelector('.notify-set1');
      const notifyPrivacy = modal.querySelector('.notify-privacy');
      const submitBtn = modal.querySelector('.notify-submit');

      if (notifySet1) {
        notifySet1.innerHTML = `<p>You’re on the waitlist!</p> <p>We will notify you when the item becomes available.</p><p>&nbsp;</p><div class="notify-divider"></div>`;
      }
      if (notifyPrivacy) {
        notifyPrivacy.style.display = 'none';
      }
      if (submitBtn) {
        submitBtn.textContent = "Close";

        submitBtn.onclick = () => {
          clearNotifySelection();
          clearVariantParamFromUrl();
          modal.remove();
        };
      }
    }

  });
});